import { CalendarDaysIcon } from '@heroicons/react/20/solid'
import { t } from 'i18next'
import DatePicker from 'react-datepicker'
import config from '../../config'
export interface ICalendarIcon {
    name?: string
    inputID: string
    handleDateChange?: any
    selectedDate?: any
    maxDate?: Date
    minDate?: Date
    maxYear?: number
    onSelect?: any
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
}

const CalendarIcon: React.FC<ICalendarIcon> = ({
    handleDateChange,
    selectedDate,
    maxDate,
    maxYear,
    minDate,
    onBlur,
    onFocus,
    onSelect,
    inputID
}) => {
    const handleChangeYear = (
        event: React.ChangeEvent<HTMLSelectElement>,
        changeYear: (year: number) => void
    ) => {
        const year = parseInt(event.target.value)
        const newDate = new Date(selectedDate || new Date())
        newDate.setFullYear(year)

        // Update the year in the date picker
        changeYear(year)
    }
    const handleCalendarOpen = () => {
        document.addEventListener('touchstart', (event: TouchEvent) => {
            event.stopPropagation();
        }, true);
    };
    const handleChangeMonth = (
        event: React.ChangeEvent<HTMLSelectElement>,
        changeMonth: (month: number) => void
    ) => {
        const month = event.target.value
        const newDate = new Date(selectedDate || new Date())
        newDate.setMonth(months.indexOf(month))

        // Update the month in the date picker
        changeMonth(months.indexOf(month))
    }
    const getYear = (date: Date) => {
        return date.getFullYear()
    }

    const getMonth = (date: Date) => {
        return date.getMonth()
    }

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear()
        const years = []
        if (maxYear) {
            for (
                let year = currentYear;
                year >= currentYear - maxYear;
                year--
            ) {
                years.push(
                    <option key={year} value={year}>
                        {year}
                    </option>
                )
            }
            return years
        } else {
            const maxPolicy = Number(config.REACT_APP_MAXPOLICY)
            const maxPolicyDate = new Date()
            maxPolicyDate.setMonth(maxPolicyDate.getMonth() + maxPolicy);
            let maxPolicyYear = maxPolicyDate.getFullYear()
            const year = new Date()
            const currentYear = year.getFullYear()
            for (maxPolicyYear;
                maxPolicyYear >= currentYear;
                maxPolicyYear--
            ) {
                years.push(
                    <option key={maxPolicyYear} value={maxPolicyYear}>
                        {maxPolicyYear}
                    </option>
                )
            }
            return years
        }
    }
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ]
    return (
        <div className='flex'>
            <DatePicker
                id={inputID}
                aria-label='Datepicker'
                className="justify-center w-[2rem] text-xs cursor-pointer"
                onChange={handleDateChange}
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                dropdownMode="select"
                popperPlacement="bottom-end"
                autoComplete="off"
                maxDate={maxDate}
                minDate={minDate}
                withPortal
                onBlur={onBlur}
                onFocus={onFocus}
                onSelect={onSelect}
                selected={selectedDate || null}
                dateFormat="MM/dd/yyyy"
                onCalendarOpen={handleCalendarOpen}
                customInput={
                    <CalendarDaysIcon className='text-[#e38026]' />
                }
                renderCustomHeader={({ date, changeYear, changeMonth }) => (
                    <div
                        style={{
                            margin: 10,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <select
                            aria-label="DatePickerYear"
                            value={getYear(date)}
                            onChange={(event) =>
                                handleChangeYear(
                                    event,
                                    changeYear as (year: number) => void
                                )
                            }
                        >
                            {generateYearOptions()}
                        </select>
                        <div className="pl-5"></div>
                        <select
                            aria-label="DatePickerMonth"
                            value={months[getMonth(date)]}
                            onChange={(event) =>
                                handleChangeMonth(
                                    event,
                                    changeMonth as (month: number) => void
                                )
                            }
                        >
                            {months.map((option) => (
                                <option key={option} value={option}>
                                    {t(option)}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            >
            </DatePicker>
        </div>
    )
}

export default CalendarIcon